/*
 * @Author: Yun
 * @Date: 2023-11-29 15:52:26
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-29 17:02:18
 */
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import firstLogo from '@icons/cgtn.jpg'
import gsap from 'gsap'
import firstTitle from '@images/firstPage/title.jpg'
import share from '@icons/share.png'
import fb from '@images/footer/fb.png'
import x from '@images/footer/x.png'
import wb from '@images/footer/wb.png'
import $ from 'jquery'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './index.less'
// let current = []

gsap.registerPlugin(ScrollTrigger)

const PREFIX = 'first-page'
const FirstPage = () => {
    useEffect(() => {
        demoTimeline()
        // goGsap()
    }, [])
    const demoTimeline = () => {
        // let tl = gsap.timeline({
        //     // yes, we can add it to an entire timeline!
        //     scrollTrigger: {
        //         trigger: '.demo1',
        //         pin: '.demo1', // pin the trigger element while active
        //         start: 'top top', // when the top of the trigger hits the top of the viewport
        //         end: '0', // end after scrolling 500px beyond the start
        //         // scrub: 0, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        //         // snap: {
        //         //     snapTo: 'labels', // snap to the closest label in the timeline
        //         //     duration: { min: 0.2, max: 3 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
        //         //     delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
        //         // },
        //         // fastScrollEnd: true,
        //         // invalidateOnRefresh: true,
        //         onUpdate: (self) => {
        //             // console.log(self)
        //         },
        //     },
        // })

        let tl = gsap.timeline()
        tl.to('body', { overflow: 'hidden' })
        for (let i = 0; i < 10; i++) {
            // console.log('iiiiiiiiiiiiiiiiiiiiii', i)
            tl.to(`.top-item-${i}`, { duration: 0.15, opacity: 0 })
                // .addLabel(`top-${i}`)
                .to(`.top-count-${i}`, { duration: 0.15, opacity: 0 })
                // .addLabel(`top-count-item-${i}`)
                .to(`.bg-item-${i}`, { duration: 0.15, opacity: 1 })
                // .addLabel(`bg-${i}`)
                .to(`.bottom-item-${i}`, { duration: 0.15, opacity: 1 })
                .addLabel(`bottom-${i}`)
            // .to(`keywords-${i}`, { duration: 0.15, opacity: 1 })
            // .addLabel(`bottom-key-${i}`)
        }
        tl.to('body', { overflow: 'auto' })
        // tl.to(`.keywords-9`, { duration: 0.1, opacity: 1 })

        // tl.addLabel('start')
        // add animations and labels to the timeline

        // tl.addLabel('end')

        let st = ScrollTrigger.create({
            trigger: '.demo1',
            start: 'top top',
            end: '+=150',
            pin: '.demo1',
            // once: true,
            // scrub: 1,
            // snap: 0,
            // pinSpacer: '',
            // pinSpacing: false,
            animation: tl,
        })
    }

    // const goGsap = () => {
    //     gsap.registerEffect({
    //         // name: 'fade',
    //         // effect: (targets, config) => {
    //         //     console.log('target', targets, 'config', config)
    //         //     return gsap.to(targets, { duration: config.duration, opacity: 0 })
    //         // },
    //         pin: '.demo1', // pin the trigger element while active
    //         defaults: { duration: 0.2 }, //defaults get applied to any "config" object passed to the effect
    //         extendTimeline: true,
    //         direction: 'down', //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
    //         scrollTrigger: {
    //             trigger: '.demo1',
    //             start: 'top top', // 当目标元素进入视口时触发
    //             end: 'bottom bottom', // 当目标元素完全离开视口时结束
    //             // onToggle: (self) => console.log('toggled. active?', self.isActive),
    //         },
    //     })

    //     // gsap.effects.fade('.demo1')
    //     let tl = gsap.timeline()
    //     tl.addLabel('start')
    //     for (let i = 0; i < 10; i++) {
    //         tl.to(`.top-item-${i}`, { duration: 0.2, opacity: 0 })
    //             .addLabel(`top-${i}`)
    //             .to(`.top-count-${i}`, { duration: 0.2, opacity: 0 })
    //             .addLabel(`top-count-item-${i}`)
    //             .to(`.bg-item-${i}`, { duration: 0.2, opacity: 1 })
    //             .addLabel(`bg-${i}`)
    //             .to(`.bottom-item-${i}`, { duration: 0.2, opacity: 1 })
    //             .addLabel(`bottom-${i}`)
    //     }
    //     tl.to(`.keywords-9`, { duration: 0.8, opacity: 1 })
    //     tl.addLabel('end')
    // }

    const topCurrentList = {
        detial: [
            {
                count: 211,
                backgroundColor: '#6648d1',
                className: 'top-item-0',
            },
            {
                count: 145,
                backgroundColor: '#a862dc',
                className: 'top-item-1',
            },
            {
                count: 120,
                backgroundColor: '#d55e53',
                className: 'top-item-2',
            },
            {
                count: 100,
                backgroundColor: '#bb9149',
                className: 'top-item-3',
            },
            {
                count: 99,
                backgroundColor: '#ebb62a',
                className: 'top-item-4',
            },
            {
                count: 77,
                backgroundColor: '#0c9ab3',
                className: 'top-item-5',
            },
            {
                count: 60,
                backgroundColor: '#027fd3',
                className: 'top-item-6',
            },
            {
                count: 56,
                backgroundColor: '#02cdda',
                className: 'top-item-7',
            },
            {
                count: 54,
                backgroundColor: '#77d495',
                className: 'top-item-8',
            },
            {
                count: 51,
                backgroundColor: '#1ca970',
                className: 'top-item-9',
            },
        ],
    }

    const bottomDivList = [
        {
            keyword1: [
                {
                    count: 13,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 21,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 17,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 3,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 5,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 2,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 5,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 7,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 0,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword2: [
                {
                    count: 25,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 4,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 13,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 9,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 9,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 8,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 5,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 7,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 0,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword3: [
                {
                    count: 15,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 16,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 0,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 6,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 5,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 5,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 6,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 9,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 3,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword4: [
                {
                    count: 23,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 8,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 12,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 11,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 8,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 4,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 6,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 6,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 6,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword5: [
                {
                    count: 13,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 5,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 1,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 8,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 1,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 1,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 2,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 5,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 15,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword6: [
                {
                    count: 14,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 27,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 2,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 11,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 3,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 2,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 3,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 4,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 6,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 5,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword7: [
                {
                    count: 0,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 0,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 2,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 0,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 0,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 0,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 0,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 0,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 0,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 2,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword8: [
                {
                    count: 15,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 23,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 14,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 8,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 3,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 0,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 2,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 3,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 9,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword9: [
                {
                    count: 19,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 7,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 17,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 10,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 8,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 5,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 9,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 2,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 8,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 3,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword10: [
                {
                    count: 19,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 4,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 18,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 10,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 17,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 20,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 7,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 4,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 8,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 3,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword11: [
                {
                    count: 20,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 7,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 13,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 18,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 18,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 15,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 5,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 5,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 2,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword12: [
                {
                    count: 9,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 7,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 9,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 6,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 6,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 5,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 3,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 2,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 2,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword13: [
                {
                    count: 16,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 6,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 2,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 0,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 4,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 8,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 7,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 0,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 1,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 0,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword14: [
                {
                    count: 10,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 10,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 0,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 0,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 12,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 2,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 0,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 2,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 1,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
        },
    ]
    const bottomObj = {
        keyword1: [73],
        keyword2: [83],
        keyword3: [58],
        keyword4: [87],
        keyword5: [52],
        keyword6: [68],
        keyword7: [4],
        keyword8: [72],
        keyword9: [87],
        keyword10: [108],
        keyword11: [106],
        keyword12: [22],
    }

    const topNameList = [
        { name: 'Development', color: '#6648d1' },
        { name: 'People', color: '#a862dc' },
        { name: 'Culture', color: '#d55e53' },
        { name: 'Industry', color: '#bb9149' },
        { name: 'Innovation', color: '#ebb62a' },
        { name: 'Technology', color: '#0c9ab3' },
        { name: 'Economy', color: '#027fd3' },
        { name: 'Modernization', color: '#02cdda' },
        { name: 'Reform', color: '#77d495' },
        { name: 'Ecology', color: '#1ca970' },
    ]

    const bottomNameList = [
        { position: 'Tianjin', num: 'February' },
        { position: 'Hunan', num: 'March' },
        { position: 'Chongqing', num: 'April' },
        { position: 'Shandong', num: 'May' },
        { position: 'Qinghai', num: 'June' },
        { position: 'Ningxia', num: 'June' },
        { position: 'Shaanxi', num: 'September' },
        { position: 'Gansu', num: 'September' },
        { position: 'Fujian', num: 'October' },
        { position: 'Anhui', num: 'October' },
        { position: 'Hubei', num: 'November' },
        { position: 'Hainan', num: 'December' },
        { position: 'Macao', num: 'December' },
        { position: 'Military', num: 'February, April, October, November, December' },
    ]

    const BackgroundColorDivs = ({ data }) => {
        return data.detial.map((item, index) => (
            <div
                key={index}
                style={{
                    transform: 'scaleY(-1)',
                    width: '8.5%',
                    margin: '0 0.75%',
                }}
            >
                {Array.from({ length: item.count }).map((_, subIndex) => (
                    <div
                        className={item.className}
                        style={{
                            display: 'inline-block',
                            backgroundColor: item.backgroundColor,
                            height: '.55vw',
                            width: '.55vw',
                            margin: '.045vw',
                            borderRadius: '50%',
                            display: 'inline-block',
                            border: 'none',
                        }}
                    ></div>
                ))}
                <div
                    className={`top-count-${index}`}
                    style={{
                        transform: 'scaleY(-1)',
                        textAlign: 'center',
                        fontSize: '1.25vw',
                        opacity: 1,
                        fontWeight: '600',
                    }}
                >
                    {item.count}
                </div>
            </div>
        ))
    }

    const KeywordDivs = ({ data }) => {
        return data.map((dataObject, dataIndex) =>
            // 遍历 dataObject 中的每个关键词及其对应的数组
            Object.keys(dataObject).map((keyword, keywordIndex) => (
                <div
                    key={`${dataIndex}-${keywordIndex}`}
                    className={`keyword-container ${keyword}`}
                    style={{
                        transform: 'scaleY(-1)',
                        flex: '1',
                        margin: '0 0.3vw',
                    }}
                >
                    {dataObject[keyword].map((item, itemIndex) =>
                        Array.from({ length: item.count }).map((_, countIndex) => (
                            <div
                                key={`${dataIndex}-${keywordIndex}-${itemIndex}-${countIndex}`}
                                style={{
                                    backgroundColor: item.backgroundColor,
                                    display: 'inline-block',
                                    height: '.55vw',
                                    width: '.55vw',
                                    margin: '.045vw',
                                    borderRadius: '50%',
                                    opacity: 0,
                                }}
                                className={item.className}
                            ></div>
                        ))
                    )}
                    {/* <div
                        className="keywords-9"
                        style={{
                            transform: 'scaleY(-1)',
                            textAlign: 'center',
                            fontSize: '1.25vw',
                            opacity: 0,
                            fontWeight: '600',
                        }}
                    >
                        {bottomObj[keyword]}
                    </div> */}
                </div>
            ))
        )
    }

    return (
        <section className={PREFIX}>
            <div className="demo1">
                <div
                    className="demo_wrapper"
                    style={{
                        // overflow: 'auto',
                        height: '100vh',
                        width: '100%',
                        scrollbarWidth: 'none',
                    }}
                >
                    <div className={`${PREFIX}-title`}>
                        <div className="title-word">
                            <div className="title-wrapper">
                                <div className="title-pt1">Keywords</div>
                                <div className="title-pt2">
                                    from official reports on Xi Jinping's tours in China in 2024
                                    indicate his priorities
                                </div>
                            </div>
                            <div className="title-pt3">
                                Chinese President Xi Jinping conducted a number of domestic tours in
                                2024 as well as trips to military facilities, highlighting key
                                priorities through frequently used keywords such as "development,"
                                "people," "culture," "industry," "innovation" and "ecology."
                                "Development" was the top keyword, emphasizing modernization and
                                economic growth. The accompanying visualization reveals keyword
                                trends and insights into each tour's focus.
                            </div>
                        </div>
                        <div className="title-pt4">
                            Word frequency is based on the 49 official Chinese news reports on
                            President Xi's tours in China in 2024.
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                height: '28vw',
                                position: 'relative',
                                width: '75vw',
                            }}
                        >
                            <div
                                className="bg-img"
                                style={{
                                    display: 'flex',
                                    position: 'absolute',
                                    top: '-3.8vw',
                                    left: 0,
                                    width: '75vw',
                                }}
                            >
                                {Array.from({ length: 10 }).map((_, countIndex) => {
                                    return (
                                        <div
                                            className={`bg-item-${countIndex}`}
                                            style={{
                                                opacity: 0,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    fontSize: '1.25vw',
                                                    fontWeight: 600,
                                                    marginBottom: '.5vw',
                                                }}
                                            >
                                                {topCurrentList.detial[countIndex].count}
                                            </div>
                                            <div className={`bg-item-bg-${countIndex}`}></div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div
                                className="top-divs-wrapper"
                                style={{
                                    display: 'flex',
                                    height: '48%',
                                    justifyContent: 'space-around',
                                    paddingBottom: '.5vw',
                                }}
                            >
                                <BackgroundColorDivs data={topCurrentList} />
                            </div>
                            <div
                                style={{
                                    paddingTop: '.2vw',
                                    fontSize: '1vw',
                                    borderTop: '0.12vw solid #000',
                                    display: 'flex',
                                }}
                            >
                                {topNameList.map((item, index) => {
                                    return (
                                        <div
                                            style={{
                                                flex: '1',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: item.color,
                                            }}
                                        >
                                            {item.name}
                                        </div>
                                    )
                                })}
                            </div>
                            <div style={{ display: 'flex', height: '42%', paddingTop: '1vw' }}>
                                <KeywordDivs data={bottomDivList} />
                            </div>
                            <div
                                style={{
                                    paddingTop: '.5vw',
                                    marginTop: '.5vw',
                                    fontSize: '12vw',
                                    borderTop: '0.12vw  solid #000',
                                    display: 'flex',
                                    width: '75vw',
                                }}
                            >
                                {bottomNameList.map((item, index) => {
                                    return (
                                        <div
                                            style={{
                                                width: '8.333%',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                            }}
                                        >
                                            <div style={{ fontSize: '1vw' }}>{item.position}</div>
                                            <div
                                                style={{
                                                    fontSize: '.6vw',
                                                    fontWeight: '400',
                                                    wordWrap: 'break-word',
                                                    color: '#919499',
                                                }}
                                            >
                                                {item.num}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FirstPage
